import ClientSmsCard from '@/components/client/client-sms-card';
import type { IClientMessage } from '@/entities/client.entity';
import { MessageSquareIcon } from 'lucide-react';

interface ClientSmsListProps {
	messages: IClientMessage[];
	onCopy: (text: string) => void;
	isSearching?: boolean;
}

export default function ClientSmsList({ messages, onCopy, isSearching = false }: ClientSmsListProps) {
	if (!messages.length) {
		return (
			<div className='flex flex-col items-center justify-center mt-10 gap-2 px-4 text-center'>
				<MessageSquareIcon size={24} className='text-muted-foreground/40' />
				<p className='text-sm text-muted-foreground'>
					{isSearching ? 'Ничего не найдено' : 'Сообщений нет'}
				</p>
			</div>
		);
	}

	return (
		<div className='flex flex-col gap-1.5 px-2'>
			{messages.map(message => (
				<ClientSmsCard key={message.id} message={message} onCopy={onCopy} />
			))}
		</div>
	);
}
